<template>
  <div class="project-list-item" style="border-bottom: 1px solid #eee;">
    <div class="item-flex" style="height: 100%;width: 100%; ">
      <writer-avatar shape="circle" :size="60" :writer="project.articles[0].article.writer" :count="project.articles.length"
                     @click="go_writer(project.articles)" :key="project.project_id"></writer-avatar>
      <div class="project-conent" style="margin-left: 10px" v-on:click="go_detail(project.project_id)">
        <div class="van-multi-ellipsis--l2" style="font-size: 14px;color:#303133">
          <van-tag :type="project.category==='篮球'?'warning':'primary'" style="margin-left: 1px;margin-right: 4px;">{{project.category}}</van-tag>
          <span class="u-m-l-10">{{project.title}}</span>
        </div>
        <div class="van-ellipsis" style="font-size: 13px;color: #909399;margin-top: 10px;margin-bottom: 10px">
          {{project.articles[0].article.article_content_visible}}
        </div>
        <div style="display: flex;flex-direction: row;justify-content: space-between;align-items: center">
          <div style="display: flex;flex-direction: row;justify-content: flex-start;align-items: center;overflow: hidden;">
            <div class="project-tongji-wrap" style="font-size: 12px;color: #909399"><van-icon name="balance-o"></van-icon><span>{{project.price | price}}</span></div>
            <div v-if="project.project_label" style="display: flex;flex-direction: row;justify-content: flex-start;overflow: hidden;font-size: 12px;color: #909399;">
              <div>【</div>
              <div  class="van-ellipsis"><span>{{project.project_label}}</span>
              </div>
              <div>】</div>
            </div>
          </div>
          <van-tag v-if="project.state === 2" type="danger" style="margin-left: 1px;margin-right: 4px;min-width: 30px" color="#ccc">已结束</van-tag>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import avatar_group from '@/assets/avatar_group.png'
    import game_over from '@/assets/game_over.png'
    import WriterAvatar from "@/views/components/WriterAvatar";
    export default {
        name: "ProjectItem",
        components:{
          WriterAvatar
        },
        filters:{
            price($value){
                if($value<=0)
                    return '免费'
                else
                    return  $value
            }
        },
        props:{
            project: {
                type: Object,
                required: true,
                default () {
                    return {
                        refresh:false,
                        project_id:0,
                        is_multi:true,//是否是合集方案
                        articles:[],
                        avatar:'',
                        category:'足球',
                        title:'',
                        content_visible:'',
                        price:'0',
                        borwser_num:0,
                        state:1,
                        project_label:''
                    }
                }
            }
        },
        computed:{
        },
        data() {
            return {
                images:{
                    avatar_group:avatar_group,
                    game_over:game_over
                },
            }
        },
        methods:{
            go_detail: function (ID) {
                // if(!this.weconfig.is_logined() || !this.westore.getters.logined){
                //     this.$router.push({
                //         name: this.werouter.login.name,
                //         query: {redirect_name:this.werouter.index.name}
                //     }).catch(function () {})
                //     return
                // }
                this.$router.push({ name: this.werouter.project.name, params: { project_id: ID } })
                if(this.project.refresh){
                    location.reload()
                }
            },
            go_writer:function (articles) {
                if(!this.westore.getters.logined){
                    this.$router.push({
                        name: this.werouter.login.name,
                        query: {redirect_name:this.werouter.index.name}
                    }).catch(function () {})
                    return
                }
                if(articles.length>0){
                    this.$router.push({ name: this.werouter.authordetail.name, params: { writer_id: articles[0].article.writer.writer_id } })

                }
            }
        }
    }
</script>

<style scoped>
.item-flex{
  display: flex;
  flex-display: row;
  justify-content: flex-start;
  align-items: center;
}
.project-conent {
  width: calc(100% - 60px - 15px);
}

.project-avatar {
  height: 60px;
  width: 60px;
  min-width: 60px;
  margin-right: 15px;
  border-radius: 60px;
}

.project-list {
  /* width: 100%; */
}

.project-list-item {
  /* width: 100%; */
  /* height: calc(200rpx - 40rpx); */
  padding: 15px 7px;
  position: relative;
  border-bottom: none;
}
    .project-avatar-wrap{
        height: 100%;
        padding: 0 0 0 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        max-width: 72px;
        max-height: 72px;
    }
    .project-over{
        height: 100%;
        padding: 0 0 0 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        max-width: 72px;
        max-height: 72px;
    }
    .project-item{
        position: relative;
        height: 100%;
        padding: 0 0 0 0;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: flex-start;
    }

    .project-tongji-wrap{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        margin-right: 4px;
    }
    .project-tongji-wrap span{
        margin-left: 5px;
    }
</style>
